import React  from 'react';
import '../myutils';
import {
    Datagrid,
    DateField,
    List, 
    Responsive,
    Show,
    DeleteButton,
    SimpleList,
    TextField,
    SimpleShowLayout, translate
} from 'react-admin'; 
import PropTypes from 'prop-types';
import {configAPI} from '../config';
import ActionDelete from '@material-ui/icons/Delete';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';


const DeleteCampaign = ({ source, record = {} }) => 
    <div onClick={() => HandleClick(record["id"])}>
        <ActionDelete>{record[source]}</ActionDelete>
    </div>;


const HandleClick = (id) => {
    const request = new Request(configAPI.api.prod+'DeleteScheduledCampaign?token='+sessionStorage.B.encodeDecode()+'&schedId='+id)
    return fetch(request)
    .then(resp => { return resp.json();})
        .then(responseRun => {
            if (responseRun.responseStatus==='OK') alert ('הקמפיין בוטל בהצלחה!')
        });

}

DeleteCampaign.propTypes = {
    addLabel: PropTypes.bool,
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

DeleteCampaign.defaultProps = {
  addLabel: true,
};

// export default DeleteCampaign;

class ScheduledList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }

    render() {
        const { translate, push, ...props } = this.props;
        return (
            <>
                <AppBar position="static" color="default" elevation={1}>
                    <Toolbar>
                    <Typography variant="title" color="inherit" style={{width:'80%', float:"right"}}>
                        {translate('resources.Scheduled.name')}
                    </Typography>
                    <Typography variant="title" color="inherit" style={{width:'20%', float:"left"}}>
                    </Typography>
                    </Toolbar>
                </AppBar>
        
                <List
                    {...props}
                    sort={{ field: 'published_at', order: 'DESC' }}
                >
                    <Responsive
                        small={
                            <SimpleList
                                primaryText={record => record.title}
                                secondaryText={record => `${record.views} views`}
                                tertiaryText={record =>
                                    new Date(record.published_at).toLocaleDateString()}
                            />
                        }
                        medium={
                            <Datagrid>
                                <TextField source="schedId" label='resources.scheduled.schedID' />
                                <TextField source="ip" label='resources.scheduled.ip' />
                                <DateField source="createTime" label='resources.scheduled.createTime' />
                                <DateField source="startTime" label='resources.scheduled.startTime' />
                                <DeleteButton />
                            </Datagrid>
                        }
                    />
                </List>
            </>
        );
    }
}

export default (translate(ScheduledList));


export const ScheduledShow = (props) => (
    <Show {...props}>
        <SimpleShowLayout>
            <TextField source="schedId" label='resources.scheduled.schedID'/>
            <TextField source="ip" label='resources.scheduled.ip'/>
            <DateField source="createTime" label='resources.scheduled.createTime'/>
            <DateField source="startTime" label='resources.scheduled.startTime'/>
        </SimpleShowLayout>
    </Show>
);